import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export type UniDriverFactory<T> = (
  base: UniDriver,
  body: UniDriver,
  options?: {
    dataHook?: string;
  },
) => T;
